import { Component, Input } from '@angular/core';
import {AppAlertService, PopupService, SubtitlesService} from "../../core";


@Component({
  selector: 'app-user-information',
  templateUrl: './user-information.component.html',
  styleUrls: ['./user-information.component.scss']
})
export class UserInformationComponent {
  @Input() item: any;
  @Input() key: any;

  constructor(
      public subtitles: SubtitlesService,
      private appAlert: AppAlertService,
      public popup: PopupService,
  ) {}

  closePopup(key: any): void {
    this.appAlert.closePopup(key);
  }

}